import { useMutation, useQueryClient } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useDeleteAccountVelocityMembership(accountId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (membershipId: string) => UsersService.deleteAccountVelocityMembership(accountId, membershipId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: usersQueryKeys.velocityMembershipList(accountId) });
    },
  });
}
